import type { GridViewPreference } from '../../../../api/userPreferencesApi'

export const GRID_VIEW_MODE_STORAGE_KEY = 'timeEntriesGridViewMode'
export const GRID_VIEW_PREFERENCE_CHANGED_EVENT =
  'mira:grid-view-preference-changed'

export const storeGridViewPreference = (view: GridViewPreference) => {
  window.dispatchEvent(
    new CustomEvent<GridViewPreference>(GRID_VIEW_PREFERENCE_CHANGED_EVENT, {
      detail: view,
    })
  )
}
